var React = require('react');

function Error (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"bxs-error","d":"M9.529,3.357a.625.625,0,0,0-1.061,0l-5.4,10.2a.6.6,0,0,0,.53.881H14.4a.6.6,0,0,0,.53-.88Zm.07,9.28H8.4v-1.2H9.6Zm-1.2-2.4v-3H9.6v3Z","transform":"translate(-2.998 -3.062)","fill":"#e30520"}));
}

Error.defaultProps = {"width":"1em","height":"1em","viewBox":"0 0 12 11.374","stroke":"currentcolor","fill":"currentcolor","strokeWidth":"0"};

module.exports = Error;

Error.default = Error;
